import Vue from "vue";

export default {
  // Captcha!
  async getCaptcha() {
    return await Vue.prototype.$http.put("accesscontrol/captcha/image");
  },
  // Remove OTP temporariamente
  async removeHotpTemporarily(username, captcha) {
    const options = {
      headers: {
        "X-USERNAME": username,
        "Content-Type": "application/json"
      }
    };
    return await Vue.prototype.$http.post(
      "solicitation/hotp/header?captcha=" + captcha,
      "",
      options
    );
  },
  // Analise de Conta - Outros Problemas
  async accountAnalysis(username, captcha) {
    return await Vue.prototype.$http.post("helpcenter", {
      userDTO: { username: username },
      captcha: captcha
    });
  },
  // Passo 1 - Extender Senha
  async requestTokenForExtendPassword(accessToken) {
    const options = {
      headers: {
        "X-ACCESS-TOKEN": accessToken,
        "Content-Type": "application/json"
      }
    };
    return await Vue.prototype.$http.post(
      "password/expiration/extend/init",
      "",
      options
    );
  },
  // Passo 2 - Extender Senha (Verifica o SMS Enviado no passo anterior)
  async verifySmsToken(tokenSms, accessToken) {
    const options = {
      headers: {
        "X-ACCESS-TOKEN": accessToken,
        "Content-Type": "application/json"
      }
    };
    return await Vue.prototype.$http.post(
      "accesscontrol/authfactor",
      { authFactorToken: tokenSms },
      options
    );
  },
  // Passo 3 - Extender Senha (Após Token verificado, executa a ação para extender senha)
  async extendPassword(accessToken) {
    const options = {
      headers: {
        "X-ACCESS-TOKEN": accessToken,
        "Content-Type": "application/json"
      }
    };
    return await Vue.prototype.$http.put(
      "password/expiration/extend",
      "",
      options
    );
  },
  // Desbloquear Conta
  async unlockAccount(accessToken) {
    const options = {
      headers: {
        "X-ACCESS-TOKEN": accessToken,
        "Content-Type": "application/json"
      }
    };
    return await Vue.prototype.$http.put("unlock/password", "", options);
  }
};
